import axios, {type AxiosInstance, type AxiosResponse} from 'axios'

interface ApiError {
  message: string
  code: number
}

const axiosInstance: AxiosInstance = axios.create()

export const CancelToken = axios.CancelToken

axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: any): Promise<never> => {
    if (error.response) {
      const message: string = error.response.data.error_message
        || error.response.data.errorMessage
        || (error.response.data.error && error.response.data.error.message)
        || error.toString()
      const code: number = parseInt(
        error.response.data.error_code
        || error.response.data.errorCode
        || (error.response.data.error && error.response.data.error.code)
        || error.response.status
      )
      return Promise.reject({message, code} as ApiError)
    } else {
      return Promise.reject(error)
    }
  }
)

export default axiosInstance
